import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface SoftwarePackageVersionTableFilterValues {
  version: string;
}

interface SoftwarePackageVersionTableFilterProps
  extends PropsWithChildren<any> {
  setFilterArgs: React.Dispatch<
    React.SetStateAction<SoftwarePackageVersionTableFilterValues | undefined>
  >;
}

export const SoftwarePackageVersionTableFilter = ({
  children,
  setFilterArgs
}: SoftwarePackageVersionTableFilterProps) => {
  const filterItems: Item<SoftwarePackageVersionTableFilterValues>[] = [
    {
      name: "version",
      type: "searchBox",
      stickItem: true,
      props: {
        placeholder: "Search by version",
        removeSpecialCharacters: false
      }
    }
  ];

  return (
    <FilterBar<SoftwarePackageVersionTableFilterValues>
      items={filterItems}
      initialValues={{
        version: ""
      }}
      onChange={filter =>
        setFilterArgs({ version: filter.state.values.version })
      }
    >
      {children}
    </FilterBar>
  );
};
